export default __webpack_public_path__ + "static/media/expand.a2e64698.svg";